export default __webpack_public_path__ + "static/media/dotIcon.e20c06b1.svg";